var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Layout", [
    _c(
      "div",
      {
        staticClass:
          "main d-flex flex-column align-items-center justify-content-center"
      },
      [
        _c("div", { staticClass: "main__text" }, [
          _c("span", { staticClass: "t--fontbold" }, [_vm._v("ONE")]),
          _vm._v(" offers online payment solutions for you to "),
          _c("span", { staticClass: "t--fontbold" }, [
            _c("br"),
            _vm._v("pay easily and securely ")
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "main__btnGrp d-flex container justify-content-center"
          },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "btn btn--bg btn--pink btn--font d-flex align-items-center justify-content-center",
                attrs: {
                  to:
                    (_vm.countryCode ? "/" + _vm.countryCode : "") +
                    "/create-po"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    this.getDisplayText("landingPage_createPO_button_text")
                  )
                )
              ]
            ),
            _c(
              "a",
              {
                staticClass:
                  "ml-64 btn btn--bg btn--white btn--font d-flex align-items-center justify-content-center",
                on: { click: _vm.goToPayPOPage }
              },
              [
                _vm._v(
                  _vm._s(this.getDisplayText("landingPage_payPO_button_text"))
                )
              ]
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }